import { render, staticRenderFns } from "./SetarAmbienteSSOV2.vue?vue&type=template&id=bcb6917e&scoped=true&"
import script from "./SetarAmbienteSSOV2.vue?vue&type=script&lang=js&"
export * from "./SetarAmbienteSSOV2.vue?vue&type=script&lang=js&"
import style0 from "./SetarAmbienteSSOV2.vue?vue&type=style&index=0&id=bcb6917e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb6917e",
  null
  
)

export default component.exports